import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_APPLICATIONNOTEPATIENT_FULFILLED = "FETCH_APPLICATIONNOTEPATIENT_FULFILLED";
export const FETCH_APPLICATIONNOTEPATIENT_REJECTED = "FETCH_APPLICATIONNOTEPATIENT_REJECTED";
export const FETCH_APPLICATIONNOTEPATIENT_PENDING = "FETCH_APPLICATIONNOTEPATIENT_PENDING";
export const RESET_APPLICATIONNOTEPATIENT = "RESET_APPLICATIONNOTEPATIENT"

export function applicationNotePatient(applicationId) {
    const token = localStorage.getItem("accessToken")

    return dispatch => {
        dispatch({
          type: "FETCH_APPLICATIONNOTEPATIENT",
          payload: axios({
            method: "get",
            url: `${API_BASE}/api/v3/second-opinion/application-note-patient-history?applicationId=${applicationId}`,
            headers: {
                "Authorization": "Bearer " + token,
                "Accept-Language": "tr-tr",
                "Client-Id": localStorage.getItem("One-Id"),
                "One-Id": localStorage.getItem("Client-Id"),
                "Content-Type": "application/json",
                "ngrok-skip-browser-warning" : "69920"
            },
          }).then((result) => result.data),
        });
      };
}


export function resetApplicationNotePatient() {
  return (dispatch) => {
      dispatch({
          type: "RESET_APPLICATIONNOTEPATIENT",
      });
  };
}


